import axios from "../axiosPlugin.js";

export const getIngredientList = (data, loading = true, isDefaultAlertTips = true) => {
  return axios({
    url: "/api/ingredient/list",
    method: "get",
    data: {
      data,
      loading,
      isDefaultAlertTips,
    },
  });
};

export const approveIngredient = (data, loading = true) => {
  return axios({
    url: "/api/ingredient/approve?cinemaId=" + data.cinemaId,
    method: "post",
    data: {
      // data,
      loading,
    },
  });
};

export const createIngredient = (data, loading = true) => {
  return axios({
    url: "/api/ingredient/create",
    method: "post",
    data: {
      data,
      loading,
    },
  });
};

export const getIngredientDetial = (data, loading = true) => {
  return axios({
    url: "/api/ingredient/detail/" + data.id,
    method: "get",
    data: {
      // data,
      loading,
    },
  });
};

export const updateIngredient = (data, loading = true) => {
  return axios({
    url: "/api/ingredient/update",
    method: "put",
    data: {
      data,
      loading,
    },
  });
};

export const deleteIngredient = (data, loading = true) => {
  return axios({
    url: "/api/ingredient/delete/" + data.id,
    method: "delete",
    data: {
      // data,
      loading,
    },
  });
};

export const updateInventory = (data, loading = true) => {
  return axios({
    url: "/api/ingredient/updateInventory?" + data,
    method: "post",
    data: {
      // data,
      loading,
    },
  });
};

export const ingredientInventoryExport = data => {
  return axios({
    url: "/api/ingredient/inventoryExport",
    method: "get",
    data: {
      data: {
        ...data,
        isDownladFile: true,
      }
    },
  });
};

export const ingredientExport = data => {
  return axios({
    url: "/api/ingredient/export",
    method: "get",
    data: {
      data: {
        ...data,
        isDownladFile: true,
      }
    },
  });
};

